import React, { useState } from 'react';
import { PaystackPayment } from './PaystackPayment';
interface PaymentFormProps {
  onSuccess?: (reference: string) => void;
}
export const PaymentForm: React.FC<PaymentFormProps> = ({
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    sex: '',
    phone: '',
    location: '',
    industry: '',
    occupation: '',
    commitment: '',
    mediaConsent: '',
    comments: ''
  });
  const [isFormComplete, setIsFormComplete] = useState(false);
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Check if required fields are complete
    setTimeout(() => {
      const requiredFields = ['email', 'fullName', 'sex', 'phone', 'location', 'industry', 'occupation', 'commitment', 'mediaConsent'];
      const isComplete = requiredFields.every(field => formData[field]);
      setIsFormComplete(isComplete && formData.email.includes('@'));
    }, 100);
  };
  return <div className="w-full max-w-lg mx-auto" data-id="element-968">
      <div className="mb-6" data-id="element-969">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-970">
          Join The Networking Salon Inner Circle
        </h2>
        <p className="text-gray-600 mb-4" data-id="element-971">
          Complete the form below to join for ₦20,000 (Founder's Offer)
        </p>
      </div>
      <div className="space-y-4 mb-6" data-id="element-972">
        <div data-id="element-973">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-974">
            Email <span className="text-gray-500" data-id="element-975">(required)</span>
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your email address" required data-id="element-976" />
        </div>
        <div data-id="element-977">
          <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-978">
            Full Name <span className="text-gray-500" data-id="element-979">(required)</span>
          </label>
          <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your full name" required data-id="element-980" />
        </div>
        <div data-id="element-981">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-982">
            Sex <span className="text-gray-500" data-id="element-983">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-984">
            {['Male', 'Female'].map(option => <div key={option} className="flex items-center" data-id="element-985">
                <input type="radio" id={`sex-${option}`} name="sex" value={option} checked={formData.sex === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-986" />
                <label htmlFor={`sex-${option}`} className="text-gray-700" data-id="element-987">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-988">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-989">
            Phone Number <span className="text-gray-500" data-id="element-990">(required)</span>
          </label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your phone number" required data-id="element-991" />
        </div>
        <div data-id="element-992">
          <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-993">
            City of Residence <span className="text-gray-500" data-id="element-994">(required)</span>
          </label>
          <select id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md" data-id="element-995">
            <option value="" data-id="element-996">Select your city</option>
            <option value="Houston Texas" data-id="element-997">Houston Texas</option>
            <option value="Lagos" data-id="element-998">Lagos</option>
            <option value="Abuja" data-id="element-999">Abuja</option>
            <option value="Benin City" data-id="element-1000">Benin City</option>
            <option value="Warri" data-id="element-1001">Warri</option>
            <option value="Berlin" data-id="element-1002">Berlin</option>
            <option value="Port Harcourt" data-id="element-1003">Port Harcourt</option>
            <option value="UK" data-id="element-1004">UK</option>
            <option value="Other" data-id="element-1005">Other</option>
          </select>
        </div>
        <div data-id="element-1006">
          <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1007">
            Industry <span className="text-gray-500" data-id="element-1008">(required)</span>
          </label>
          <input type="text" id="industry" name="industry" value={formData.industry} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your industry" required data-id="element-1009" />
        </div>
        <div data-id="element-1010">
          <label htmlFor="occupation" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1011">
            What do you do? <span className="text-gray-500" data-id="element-1012">(required)</span>
          </label>
          <textarea id="occupation" name="occupation" value={formData.occupation} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Describe your occupation or role" required data-id="element-1013" />
        </div>
        <div data-id="element-1014">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1015">
            Are you committed to actively participating in the ways described
            above? <span className="text-gray-500" data-id="element-1016">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-1017">
            {['Yes', 'No', 'I have questions'].map(option => <div key={option} className="flex items-center" data-id="element-1018">
                <input type="radio" id={`commitment-${option}`} name="commitment" value={option} checked={formData.commitment === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1019" />
                <label htmlFor={`commitment-${option}`} className="text-gray-700" data-id="element-1020">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1021">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1022">
            Are you okay with your pictures and videos of you taken at our
            events (in-person or online) be used for promotional purposes?{' '}
            <span className="text-gray-500" data-id="element-1023">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-1024">
            {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-1025">
                <input type="radio" id={`mediaConsent-${option}`} name="mediaConsent" value={option} checked={formData.mediaConsent === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1026" />
                <label htmlFor={`mediaConsent-${option}`} className="text-gray-700" data-id="element-1027">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1028">
          <label htmlFor="comments" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1029">
            Additional Comments or Suggestions (You can ask your questions
            here): <span className="text-gray-500" data-id="element-1030">(optional)</span>
          </label>
          <textarea id="comments" name="comments" value={formData.comments} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter any additional comments or questions" data-id="element-1031" />
        </div>
      </div>
      {isFormComplete ? <PaystackPayment amount={20000} email={formData.email} name={formData.fullName} phone={formData.phone} onSuccess={onSuccess} metadata={{
      ...formData
    }} data-id="element-1032" /> : <button disabled className="w-full py-2 px-4 bg-gray-300 text-gray-500 rounded-md cursor-not-allowed" data-id="element-1033">
          Complete all required fields to proceed
        </button>}
    </div>;
};